import Vue from 'vue';
import Vuex from 'vuex';
import Deal from '@/store/Deal';
import Form from '@/store/Form';
import Cookie from '@/store/cookie';
import instForm from '@/store/instStepForm'


Vue.use(Vuex);


export default new Vuex.Store({
  modules:{
    Deal,
    Form,
    Cookie,
    instForm
  }
});
